module.exports = __webpack_public_path__ + "img/28 Animation 2-squashed.e980c90d.jpg";